import React, { forwardRef } from 'react'
import type { TargetShape } from '../types'

interface PreviewStageProps {
  targetShape: TargetShape
}

export const PreviewStage = forwardRef<HTMLDivElement, PreviewStageProps>(
  ({ targetShape }, ref) => {
    return (
      <div className="flex-1 relative overflow-hidden bg-gray-50">
        {/* Dot grid background */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle, #d1d5db 1px, transparent 1px)',
            backgroundSize: '24px 24px',
          }}
        />

        {/* Origin crosshair */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
          <div className="w-8 h-px bg-gray-300" />
          <div className="w-px h-8 bg-gray-300 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
        </div>

        {/* Animated target element */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <div ref={ref}>
            {targetShape === 'box' && <BoxShape />}
            {targetShape === 'circle' && <CircleShape />}
            {targetShape === 'card' && <CardShape />}
          </div>
        </div>
      </div>
    )
  }
)

PreviewStage.displayName = 'PreviewStage'

function BoxShape() {
  return (
    <div className="w-[120px] h-[120px] rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 shadow-lg" />
  )
}

function CircleShape() {
  return (
    <div className="w-[120px] h-[120px] rounded-full bg-gradient-to-br from-pink-500 to-rose-600 shadow-lg" />
  )
}

function CardShape() {
  return (
    <div className="w-[160px] h-[100px] rounded-xl bg-white shadow-lg border border-gray-100 p-4 flex flex-col justify-between">
      <div className="h-2.5 w-20 bg-gray-800 rounded-full" />
      <div className="space-y-1.5">
        <div className="h-2 w-full bg-gray-200 rounded-full" />
        <div className="h-2 w-3/4 bg-gray-200 rounded-full" />
      </div>
    </div>
  )
}
